export const dynamicPagesApiHandler = {
  getOrganizationPages: {
    method: "GET",
    path: () => `org-dynamic-pages-management`
  },
  createPage: {
    method: "POST",
    path: () => `org-dynamic-pages-management`
  },
  deletePage: {
    method: "DELETE",
    path: (payload: { pageId: string | number }) => `org-dynamic-pages-management/${payload.pageId}`
  },
  updatePage: {
    method: "PATCH",
    path: (payload: { pageId: string | number }) => `org-dynamic-pages-management/${payload.pageId}`
  },
  getSinglePage: {
    method: "GET",
    path: (payload: { pageId: string | number }) => `org-dynamic-pages-management/${payload.pageId}`
  }
};